let unit = {
    name: '',
    logo: ''
};

export default unit;